import { dealer_codes_list, getFullText } from "../config/constant";
import {
  CustomerVisitReport,
  LoginActivity,
  PartKartLoginActivity,
  AverageNumberOfPartsPerLead,
  LeadInformation,
  LocationUpdateStatus,
  OrderValue,
  OrderCollectionReport,
  IwResearch,
  NoStock,
  PartskartOrderCollection,
} from "../store/constants/constants";
import axiosServices from "./axios";

export const formateNumber = (number) => number.toLocaleString("en-IN");
export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const hideKPI = (kpi, user_role, kpi_list) => {
  if (user_role !== "1" && user_role !== "2") {
    if (kpi_list.indexOf(kpi) === -1) {
      return true;
    }
  }
  return false;
};

export const commonNumericColTableSort = (rowA, rowB, columnId) => {
  // Convert locale-formatted string to numbers before sorting
  if (
    typeof rowA.values[columnId] == "number" &&
    typeof rowB.values[columnId] == "number"
  )
    return rowA.values[columnId] - rowB.values[columnId];
  const valueA = parseFloat(rowA.values[columnId].replace(/,/g, ""));
  const valueB = parseFloat(rowB.values[columnId].replace(/,/g, ""));
  // Return comparison result
  return valueA - valueB;
};

export const commonRupeeColSort = (rowA, rowB, columnId) => {
  if (
    typeof rowA.values[columnId] == "number" &&
    typeof rowB.values[columnId] == "number"
  )
    return rowA.values[columnId] - rowB.values[columnId];
  const valueA = parseFloat(rowA.values[columnId].replace(/[^\d.-]/g, ""));
  const valueB = parseFloat(rowB.values[columnId].replace(/[^\d.-]/g, ""));
  return valueA - valueB;
};

export const processCumulativeReportData = (data) => {
  return data;
};
export const processLoginActivityData = (data) => {
  return data;
};
export const processPartskartLoginActivityData = (data) => {
  return data;
};
export const processPartsPerLeadData = (data) => {
  return data;
};

export const processAppUsageActivityData = (data) => {
  return data;
};

export const processLocationUpdateData = (data) => {
  return data;
};

export const processTopDseData = (data) => {
  return data;
};
export const processCustomerVisitData = (data) => {
  return data;
};
export const processAdvanceVisitData = (data) => {
  return data;
};

export const processPartisVisitedTopDSE = (data) => {
  return data;
};

export const processOrderCollectionData = (data) => {
  return data;
};
export const processPartskartOrderCollectionData = (data) => {
  return data;
};

export const processIwResearchData = (data) => {
  return data;
};
export const processCumulativeIWResearch = (data) => {
  return data;
};
export const processNoStockData = (data) => {
  return data;
};

export const getCodeName = (code) => {
  if (code === null || code === undefined || code === "") return null;
  code = code.toLowerCase();
  const name = getFullText[code[0]];
  if (code.length === 1) return name;
  const match = code.match(/\d+/);
  const extractedNumber = parseInt(match[0], 10);
  return `${name} ${extractedNumber}`;
};

export const formatDateOne = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getDayDifference = (date1, date2) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const firstDate = new Date(date1).getTime();
  const secondDate = new Date(date2).getTime();
  const differenceMs = Math.abs(secondDate - firstDate);
  return Math.round(differenceMs / oneDay);
};

async function cumulativeGeoTaggingReport(payload, kpi) {
  try {
    const additionalWorksheetData = await axiosServices.post(
      `/additional-data/cumulative-geotagging-data?kpi=${kpi}`,
      payload
    );

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong service");
  }
}
async function cumulativeIWResearchReport(payload, kpi) {
  try {
    const additionalWorksheetData = await axiosServices.post(
      `/additional-data/cumulative-iwresearch-data?kpi=${kpi}`,
      payload
    );

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong service");
  }
}

async function iwResearchReport(payload, kpi) {
  try {
    const additionalWorksheetData = await axiosServices.post(
      `/additional-data/dcrc-data?kpi=${kpi}`,
      payload
    );

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong service");
  }
}

async function noStockReport(payload, kpi) {
  try {
    const additionalWorksheetData = await axiosServices.post(
      `/additional-data/nostock-data?kpi=${kpi}`,
      payload
    );

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong service");
  }
}

async function loginKpiAdditionalWorksheet(payload, kpi) {
  try {
    const additionalWorksheetData = await axiosServices.post(
      `/additional-data/login-data?kpi=${kpi}`,
      payload
    );

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong");
  }
}

async function partskartLoginKpiAdditionalWorksheet(payload, kpi, partyFilter) {
  try {
    let url = `/additional-data/partskart-login-data?kpi=${kpi}`;
    if (partyFilter) url += `&partyFilter=${partyFilter}`;
    const additionalWorksheetData = await axiosServices.post(url, payload);
    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("Wrong Service");
  }
}

async function partskartOrdersKpiAdditionalWorksheet(
  payload,
  kpi,
  partyFilter,
  orderTypeDownload
) {
  let url = `/additional-data/partskart-orders-data?kpi=${kpi}`;
  if (partyFilter) url += `&partyFilter=${partyFilter}`;
  if (orderTypeDownload) url += `&orderType=${orderTypeDownload}`;
  try {
    const additionalWorksheetData = await axiosServices.post(url, payload);
    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
  }
}

async function customerVisitReportKpiAdditionalWorksheet(
  payload,
  kpi,
  partyFilter
) {
  try {
    let url = `/additional-data/customervisit-data?kpi=${kpi}`;
    if (partyFilter) {
      url = `/additional-data/customervisit-data?kpi=${kpi}&partyFilter=${partyFilter}`;
    }

    const additionalWorksheetData = await axiosServices.post(url, payload);

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong");
  }
}

async function averageNumberOfPartsPerLeadKpiAdditionalWorksheet(
  payload,
  kpi,
  partsKPIpartyType,
  partsKPIPartCategory
) {
  try {
    const additionalWorksheetData = await axiosServices.post(
      `/additional-data/partsanalysis-data?kpi=${kpi}&partyFilter=${
        partsKPIpartyType || "ignore"
      }&partCategory=${partsKPIPartCategory || "ignore"}`,
      payload
    );

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong");
  }
}
// async function leadInformationKpiAdditionalWorksheet(payload, kpi) {
//   try {
//     const additionalWorksheetData = await axiosServices.post(
//       `/additional-data/topdse-data?kpi=${kpi}`,
//       payload
//     );

//     return additionalWorksheetData.data.data;
//   } catch (error) {
//     console.log(error?.message);
//     throw new Error("wrong");
//   }
// }
async function locationUpdateStatusKpiAdditionalWorksheet(payload, kpi) {
  try {
    const additionalWorksheetData = await axiosServices.post(
      `/additional-data/locationupdate-data?kpi=${kpi}`,
      payload
    );

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong");
  }
}

async function orderValueKpiAdditionalWorksheet(payload, kpi) {
  try {
    const additionalWorksheetData = await axiosServices.post(
      `/additional-data/topdse-data?kpi=${kpi}`,
      payload
    );

    return additionalWorksheetData.data.data;
  } catch (error) {
    console.log(error?.message);
    throw new Error("wrong");
  }
}

export const getWorkSheetData = async (
  kpi,
  payload,
  partyFilter,
  partsKPIpartyType,
  partsKPIPartCategory,
  cumulativeFlag,
  orderTypeDownload
) => {
  switch (kpi) {
    case LoginActivity:
      return await loginKpiAdditionalWorksheet(payload, kpi);
    case PartKartLoginActivity:
      return await partskartLoginKpiAdditionalWorksheet(
        payload,
        kpi,
        partyFilter
      );
    case CustomerVisitReport:
      return await customerVisitReportKpiAdditionalWorksheet(
        payload,
        kpi,
        partyFilter
      );

    case AverageNumberOfPartsPerLead:
      return await averageNumberOfPartsPerLeadKpiAdditionalWorksheet(
        payload,
        kpi,
        partsKPIpartyType,
        partsKPIPartCategory
      );

    case LeadInformation:
    case OrderCollectionReport:
      return await orderValueKpiAdditionalWorksheet(payload, kpi);

    case PartskartOrderCollection:
      return await partskartOrdersKpiAdditionalWorksheet(
        payload,
        kpi,
        partyFilter,
        orderTypeDownload
      );

    case LocationUpdateStatus:
      if (cumulativeFlag) return await cumulativeGeoTaggingReport(payload, kpi);
      else
        return await locationUpdateStatusKpiAdditionalWorksheet(payload, kpi);

    case OrderValue:
      return await orderValueKpiAdditionalWorksheet(payload, kpi);

    case IwResearch:
      if (cumulativeFlag) return await cumulativeIWResearchReport(payload, kpi);
      else return await iwResearchReport(payload, kpi);

    case NoStock:
      return await noStockReport(payload, kpi);

    default:
      return [];
  }
};
export const getDealerName = (dealer_code) => {
  if (!dealer_code) return "Distributor Key Statistics";
  const dealer_list = Object.values(dealer_codes_list).flat();
  const dealer_info = dealer_list.find(
    (dealer) => dealer.value === dealer_code
  );
  return (
    `${dealer_info?.id.split("-").reverse()[0].trim()} (${dealer_code})` ||
    "Distributor Key Statistics"
  );
};
export const recomtestEmail = "admintest@appdashboard.com";
export const loginContent = `This KPI is indicative of the % of Sales Manpower which has logged in to the intelliSales App.

Count of Sales Manpower – This the Count of currently Active Sales Manpower (as of N-1th Day) in the Employee Master. 5 Designations have been considered in this – Sales Executive (SEP), Remote Area Sales Executive (RSE), Resident Sales Executive (RSP), Retail Executive (REP) & Retail Outlet In charge (ROI). Manpower whose Date of Leaving has been updated in the system are not considered in the count.Hence it is essential to maintain accurate data in DMS.

Count of Manpower Logged In – This KPI indicates the count of how many manpower had logged in to the App within the selected date range

A detailed report can be downloaded for analysis.
`;

export const appUsageContent = `This KPI reflect the number of manpower using the intelliSales app for ordering daily and the no. of orders being collected.

Avg. Count Of Manpower Ordering Daily – This metric represents the average number of manpower who place orders daily using the intelliSales app. For example – 5 MSPINs ordered on Day 1, 3 MSPINs on Day 2, so the Avg. will be (5+3)/2 = 4

Avg. Count Of Daily Orders – This metric reflects the average number of orders taken daily through the app, considering the specified date range filters.

A detailed report can be downloaded for analysis.`;
export const distributorPerformanceContent = `This KPI is indicative of the Distributor level performance summary based on parameters like % Sales Manpower Ordering Daily, Total Orders taken & Total Order Value generated. The Rank is provided on the basis of Order Value. 
It is calculated by – Avg. No. of Manpower Ordering Daily / Total Sales Manpower 

A detailed report can be downloaded for analysis.`;
export const distributorperformanceLoginContent = `This KPI is indicative of the Distributor level performance summary on parameters like % of Sales Manpower Ordering Daily, Total Orders taken & Total Order Value generated.

A detailed report can be downloaded for analysis.`;
export const customerVisitContent = `This KPI provides the summary of market coverage by Distributor Sales executives using intelliSales App. Details like total no. of active parties, parties where the executives have punched visits and collected orders using the App can be analysed. Below is the explanation for the market coverage calculation

Total No. Of Parties – This represents the count of all Party codes active according to DMS as of pervious day (N-1th Day). Party Types considered here include Independent Workshops (U), Traders (TR), MASS (M) & MSZ (MS)

Unique Parties Visited – This the unique count of Parties where Sales executives successfully punched the visit using the intelliSales App within the selected date range. Please Note – Any party where the Visit was punched but it was later closed as per the system within the selected date range will still be counted in this & for calculation of market coverage.

Market Coverage – (Unique Parties Visited / Total no. of Parties) * 100

A detailed report can be downloaded for further analysis..`;
export const customerVisitDistributorContent = `This KPI indicates the no. of Parties which were visited by the sales manpower in the selected time period when compared with the total no. of Active Parties. 
For date range  <=15 days daily data is shown, >15 days weekly average is shown.

Total No. of Parties – This is the count of Total No. of Party codes active as per DMS (as of N-1th Day). Party Types considered here are IWs, Traders, MASS & MSZ (U, TR, M, MS)

Total No. of Parties Visited – This the unique count of Parties where the Visit was successfully punched by the Sales Manpower within the selected date range. Please Note – Any party where the Visit was punched but it was closed as per the system within the selected date range will also be counted in this & for any further calculation.

A detailed report can be downloaded for analysis.`;
export const locationUpdateContent = `This KPI indicates how many of the total Parties were Geotagged through intelliSales App.

Total No. of Parties – This represent count of all Party codes active according to DMS as of pervious day (N-1th Day). Party Types considered here include Independent Workshops (U), Traders (TR), MASS (M) & MSZ (MS)

Parties Geotagged (since inception) – This is the cumulative count of no. of currently active parties geotagged since inception.

Parties Geotagged (selected period) – This is the count of no. of currently active parties geotagged in the selected period

Parties Pending for Geotagging – (Total No. of Parties – Parties Geotagged (since inception))

A detailed report can be downloaded for analysis.`;
export const partLevelOrderContent = `This KPI will help to track the Part Level Order Collection from the intelliSales App. By default the top 10 parts are displayed here, the rank is based on the ORder Value of Part number. 

Please Note – This report only indicates the part details captured in the App. Order amount is calculated basis the MRP of the product at the time of order collection.

A detailed report can be downloaded for analysis`;
export const salesManpowerVisitContent = `This KPI indicates the top performing Sales Manpower in terms of the % of Parties Visited by them.

Total Mapped Parties – No. of Parties mapped to the particular MSPIN as per the Party Master (as of N-1th day). Please Note: If the employee has left the system i.e Date of leaving is updated then the mapping at the time of last activity in App is considered.

Total Parties Visited – No. of Parties where the Visit was punched successfully atleast once during the selected date range.

% Parties Visited – It is calculated by the formula (Total No. of Parties Visited / Total No. of Mapped Parties) Please Note – Any party which was visited but has been closed within the selected date range is still considered under count of Parties Visited.

Rank is calculated basis the % of Total Parties Visited during the period.

A detailed report can be downloaded for Analysis.`;
export const visitTrackerContent = `This advanced feature allows the user to input any MSPIN/Party Code and see the Geotagging & Last Visited date & time of the party.

If input is MSPIN – Summary of all the mapped parties which were visited in the date range will be shown.
If input is Party Code – Date of Geotagging & last visited date and time for that Party Code will be shown.

A detailed report can be downloaded for analysis.`;

export const allIndiaKeyStatatics = `This section of the dashboard provides a performance summary of the market coverage activities done by Distributor Sales Executives using the intelliSales App. It focuses on important metrics like App Usage by Sales Manpower, Aftermarket Visits Recorded & Orders Collected through the App.

The employee designations considered as Sales Manpower are Sales Executive (SEP), Remote Area Sales Executive (RSE), Resident Sales Executive (RSP), Retail Executive (REP) & Retail Outlet In charge (ROI)
`;
export const orderCollectionContent = `This KPI indicates the order value collected by the Sales manpower using the intelliSales App within the applied date range.

The Order value is calculated as a summation of value of orders punched by the Distributor Sales team using the intelliSales App. The order value is calculated basis the MRP of the product at the time when order was punched through the App.
`;

export const partskartOrderCollectionContent = `This KPI indicates the order value of the orders submitted by B2B customers through PartsKart App in the applied date range.

The order value is calculated basis the MRP of the product at the time when order was punched through the App.
`;

export const partskartLoginContent = `This KPI is indicative of the % of Party Code which have logged in to Parts Kart App and had active sessions in the app during the selected date range.

Count of Total Parties – This is the Count of currently active Party codes (as on N-1st Day) in Party Master. Party Type considered are U- Independent Workshops, TR- Trader, M-MASS & MS-MSZ.

Count of Total Parties Logged in – This KPI indicates of how many party codes had logged in and had active sessions in the App within the selected date range.

A detailed report can be downloaded for analysis.
`;

export const iwResearchContent = `This KPI enables tracking of the number of Independent Workshop Customers whose Digital CRC form details have been captured through the intelliSales App.

Total Independent Workshops - Indicates the total active Independent Workshops in DMS as on N-1th day.

Total CRC 2.0 Forms Submitted – No. of active Independent Workshops whose CRC 2.0 forms have been submitted since inception.

CRC 2.0 Forms Submitted in Selected Period – No. of active Independent Workshops whose CRC 2.0 forms were submitted in selected period.

A detailed report can be downloaded for analysis.`;

export const noStockContent = `Within the In Parts Kart/IntelliSales application, users have the capability to check if a desired product is in stock at a specific outlet according to the quantity they need. The application also allows users to check the stock levels of the same product across various outlets. A "stock out" incident is recorded as a single occurrence when there is an insufficient quantity of stock on a specific day, identified by a unique combination of party code, part number, and quantity required. For instance, if on the 15th of April, 2025, a user named U1 conducts a stock check for one unit of part P1 across four different locations and discovers that none of the locations have the item in stock, it will be logged as only one stock out incident, despite the stock being unavailable four times.`;
